import { getIsSavedMethodsDisplayed } from "../../wrapper/PaymentWrapper/dependencies/helper";
import {
  NOT_AVAILABLE,
  PAGE_NAMES,
  PAGE_TYPES,
  TRACKING_EVENTS,
} from "../../constants";
import { AppCallback, doCallAppCallback } from "./webView";
import { checkIsRetinaEventEnabledByCode, getPaymentOffers } from "../../layouts/Payment/common/dependencies/dependencyhelpers";
import { getBucketSize } from "./getBucketSize";
import { NO_OTHER_METHOD, NO_SAVED_METHOD, PAYMENT_METHODS_DATALAYER, NEW_PAYMENT_METHODS_DATALAYER } from "constants/dataLayer";
import {
  SEMI_CLOSED_WALLET_STATES,
  WALLET_STATES,
} from "layouts/Payment/common/dependencies/constants";
import { WalletInfo } from "@nykaa/payment-sdk/src/Payment/@types";
import { ICartInfo } from "wrapper/PaymentWrapper/dependencies/utils/@types/cartInfo";
import { logger } from "logging";
import { IPaymentInfo } from "wrapper/MySavedPaymentWrapper/@types";
import { IWalletConfig } from "hooks/useNykaaWallet";
import { PaymentMethodOffer } from "logics/src/utils/@types";
import { IPaymentSuccessData, IPaymentSuccessItem } from "wrapper/PaymentSuccessWrapper/@types";
import { ICartItem } from "wrapper/PaymentWrapper/dependencies/utils/@types/cartItem";
import { PAYMENT_SCREENS } from "constants/paymentScreens";


export interface IProduct {
  productId: string;
  cartItemPriceDTO: {
    mrp: number;
    price: number;
    discount: number;
  };
  name: string;
  sku: string;
  quantity: number;
  inventory?: string;
  brandNames?: string[];
  totalPrice: number;
}

export interface RetinaTrackingDataConfig {
  event: string;
  cartInfo?: ICartInfo | {};
  paymentInfo?: IPaymentInfo | {};
  walletConfig?: IWalletConfig | {};
  paymentMethod?: string;
  paymentSuccessData?: IPaymentSuccessData | {};
  paymentSuccessItem?: IPaymentSuccessItem | {};
  orderId?: string;
  isWebView?: boolean; // for tracking the changes clearly whether these are from react code or app
}

export interface MixPanelTrackingDataConfig extends RetinaTrackingDataConfig {
  walletInfo?: WalletInfo | {};
  offersData?: PaymentMethodOffer | {};
  appliedOfferRuleId?: number;
  userData?: IUser;
  addressCount?: number;
  paymentSuccessData?: IPaymentSuccessData | {};
  isSavedPaymentMethod?: boolean;
  upiexpinput_params?: string;
  isWebView?: boolean;
  isSimplEligible?: boolean;
  isZestMoneyEligible?: boolean;
  paymentAmount?: number;
  interactionLocation?: string;
  isDefaultAddress?: boolean;
  auto_detect_permission?: string;
  errorMessage?: string;
  credPayData?: {
    credFlow: string,
    credOffer: string,
    eligible: boolean
  },
/**
   * masterPaymentStatus, paymentFallbackOptions -- keys for paymentFailureFlow tracking
   */
  masterPaymentStatus: string;
  paymentFallbackOptions: boolean;
  isCredPayInstalled?: boolean
  isLoggedIn?: boolean,
  redirectingUserToPaymentPage?: boolean,
  currency?: string,
  errorType?: string,
  isAddressServicable?: boolean,
  isWalletShown?: boolean,
  isWalletVerified?: boolean,
  paymentStatus?: string;
  isExpanded?: boolean;
  intentApp?: string;
  visibleOffers?: boolean;
  codCharge?: string;
  paymentGateway?: string;
  nativeOrderConfirmationCallbackData?: any;
  failureFlowEnabled?: boolean;
  paymentScreen?: string;
  isFirstLandingPageAfterCheckout: boolean;
  giftcardAmount?: number;
  paymentMode?: string;
  interaction_location?: string;
  payment_method_shown?: boolean;
  nykaa_wallet_shown?: boolean;
  payment_amount?: string;
  payment_method?: string;
  is_logged_in?: boolean;
  payment_offer_applied?: boolean;
  savings_amount?: string;
  payable_amount?: string;
  nykaa_wallet_applied?: boolean;
  nykaa_wallet_balance?: boolean;
  payment_offer_amount?: string;
  item_count?: string;
  pincode?: string;
  cod_charges_applied?: boolean;
  cod_charge_amount?: number;
  rewards_amount?: string;
  checkoutExperiments?: any;
}

export interface AllTrackingHandlerForAppsConfig extends RetinaTrackingDataConfig {
  walletInfo?: WalletInfo;
  offersData?: PaymentMethodOffer;
  appliedOfferRuleId?: number;
  addressCount?: number;
  paymentSuccessData?: IPaymentSuccessData | {};
  isSavedPaymentMethod?: boolean;
  upiexpinput_params?: string;
  isWebView?: boolean;
  isSimplEligible?: boolean;
  isZestMoneyEligible?: boolean;
  paymentAmount?: number;
  interactionLocation?: string;
  isDefaultAddress?: boolean;
  auto_detect_permission?: string;
  errorMessage?: string;
  isApp: boolean;
  credPayData?: {
    credFlow: string,
    credOffer: string,
    eligible: boolean
  },
  isCredPayInstalled?: boolean,
  /**
   * masterPaymentStatus, paymentFallbackOptions -- keys for paymentFailureFlow tracking
   */
  masterPaymentStatus?: string;
  paymentFallbackOptions?: boolean;
  isLoggedIn?: boolean,
  redirectingUserToPaymentPage?: boolean,
  currency?: string,
  errorType?: string,
  isAddressServicable?: boolean,
  isWalletShown?: boolean,
  isWalletVerified?: boolean,
  paymentStatus?: string;
  isExpanded?: boolean;
  intentApp?: string;
  visibleOffers?: boolean;
  codCharge?: string;
  paymentGateway?: string;
  nativeOrderConfirmationCallbackData?: any;
  failureFlowEnabled?: boolean;
  paymentScreen?: string;
  isFirstLandingPageAfterCheckout?: boolean;
  giftcardAmount?: number;
  paymentMode?: string;
  interaction_location?: string;
  payment_method_shown?: boolean;
  nykaa_wallet_shown?: boolean;
  payment_amount?: string;
  payment_method?: string;
  is_logged_in?: boolean;
  payment_offer_applied?: boolean;
  savings_amount?: string;
  payable_amount?: string;
  nykaa_wallet_applied?: boolean;
  nykaa_wallet_balance?: boolean;
  payment_offer_amount?: string;
  item_count?: string;
  pincode?: string;
  cod_charges_applied?: boolean;
  cod_charge_amount?: number;
  rewards_amount?: string;
  checkoutExperiments?: any;
}

export interface ICleverTapTrackingConfig {
  event: string;
  paymentMethod: string;
  cartInfo?: ICartInfo;
  amount?: number;
  isSavedPaymentMethod?: boolean;
  isWebView?: number;
  paymentScreen?: string;
  orderId?: string;
}

/**
 * @description -- tracking function fetches data on the basis of event type and calls callback functions on the basis of device
 * @param event - event firing
 * @param cartInfo - cart refresh
 * @param paymentInfo
 * @param walletInfo
 * @param offersData
 * @param walletConfig
 * @param paymentMethod  - mode using which doing payment
 * @param appliedOfferRuleId-- applied offer id
 */
export const allTrackingHandlerForApps = ({
  event,
  cartInfo,
  paymentInfo,
  walletConfig,
  paymentMethod = "",
  walletInfo,
  offersData,
  appliedOfferRuleId = 0,
  addressCount,
  paymentSuccessData,
  paymentSuccessItem,
  orderId,
  isSavedPaymentMethod,
  upiexpinput_params,
  isWebView = true,
  isSimplEligible = false,
  isZestMoneyEligible = false,
  paymentAmount = 0,
  interactionLocation = "",
  isDefaultAddress = false,
  auto_detect_permission,
  errorMessage = "",
  isApp,
  credPayData,
  isCredPayInstalled,
  masterPaymentStatus = "",
  paymentFallbackOptions = false,
  isLoggedIn,
  redirectingUserToPaymentPage,
  currency,
  errorType,
  paymentStatus,
  isExpanded,
  intentApp,
  visibleOffers,
  codCharge,
  paymentGateway,
  nativeOrderConfirmationCallbackData,
  failureFlowEnabled,
  paymentScreen,
  isFirstLandingPageAfterCheckout = false,
  giftcardAmount = 0,
  paymentMode,
  interaction_location,
  payment_method_shown,
  nykaa_wallet_shown,
  payment_amount,
  payment_method,
  is_logged_in,
  payment_offer_applied,
  savings_amount,
  payable_amount,
  nykaa_wallet_applied,
  nykaa_wallet_balance,
  payment_offer_amount,
  item_count,
  pincode,
  cod_charges_applied,
  cod_charge_amount,
  rewards_amount,
  checkoutExperiments,
}: AllTrackingHandlerForAppsConfig) => {
  try {
    // execute this function for app only
    if (!isApp) return;
    const retinaData = getRetinaTrackingData({
      event,
      cartInfo,
      paymentInfo,
      walletConfig,
      paymentMethod,
      paymentSuccessData,
      orderId,
      isWebView,
    });
    const mixPanelData = getMixPanelTrackingData({
      event,
      cartInfo,
      paymentInfo,
      walletInfo,
      offersData,
      walletConfig,
      paymentMethod,
      appliedOfferRuleId,
      addressCount,
      paymentSuccessData,
      paymentSuccessItem,
      isSavedPaymentMethod,
      upiexpinput_params,
      isWebView,
      isSimplEligible,
      isZestMoneyEligible,
      orderId,
      paymentAmount,
      interactionLocation,
      isDefaultAddress,
      auto_detect_permission,
      errorMessage,
      credPayData,
      isCredPayInstalled,
      masterPaymentStatus,
      paymentFallbackOptions,
      isLoggedIn,
      redirectingUserToPaymentPage,
      currency,
      errorType,
      paymentStatus,
      isExpanded,
      intentApp,
      visibleOffers,
      codCharge,
      paymentGateway,
      nativeOrderConfirmationCallbackData,
      failureFlowEnabled,
      paymentScreen,
      isFirstLandingPageAfterCheckout,
      giftcardAmount,
      paymentMode,
      interaction_location,
      payment_method_shown,
      nykaa_wallet_shown,
      payment_amount,
      payment_method,
      is_logged_in,
      payment_offer_applied,
      savings_amount,
      payable_amount,
      nykaa_wallet_applied,
      nykaa_wallet_balance,
      payment_offer_amount,
      item_count,
      pincode,
      cod_charges_applied,
      cod_charge_amount,
      rewards_amount,
      checkoutExperiments,
    });

    /**
     * This is commented as we are not using adobe tracking anymore, can be removed in future
        const adobeTrackingConfig = {
        tracker: "adobe",
        type: getAbodeEventType(event),
        name: event, // name of event/action
        data: JSON.stringify(mixPanelData),
      };
     */


    const mixpanelTrackingConfig = {
      tracker: "mixpanel",
      type: "action", // type will be action for all the mixpanel events
      name: event, // name of event/action
      data: JSON.stringify({
        ...mixPanelData,
        user_agent: navigator?.userAgent,
        network_type: navigator?.connection?.effectiveType,
        /** this is still experimental, and not supported in all browsers, so cannot be relied upon, but insights might be useful */
        network_download_speed: navigator?.connection?.downlink, // return donwload speed in mbps
        rtt: navigator?.connection?.rtt, // return round trip time in ms
      }), // Add user_agent for all the outgoing calls in dotrack for mixpanel events
    };

    const retinaTrackingConfig = {
      tracker: "retina",
      type: "state",
      name: event, // name of event/action
      data: JSON.stringify(retinaData),
    };
    //mixpanel tracking on pay now button click
    if (mixPanelData && Object.keys(mixPanelData)?.length > 0) {
      console.log(event, "mixPanelData inside allTrackingHandlerForApps", mixPanelData);
      doCallAppCallback({ name: AppCallback.DO_TRACK, data: mixpanelTrackingConfig });
    }

    //adobe tracking on pay now button click
    /**
     * This is commented as we are not using adobe tracking anymore, can be removed in future
      if (mixPanelData && Object.keys(mixPanelData)?.length > 0) {
        doCallAppCallback({ name: AppCallback.DO_TRACK, data: adobeTrackingConfig });
      }
     */


    //retina tracking on pay now button click
    if (retinaData && Object.keys(retinaData)?.length > 0) {
      console.log(event, "retinaData inside allTrackingHandlerForApps", retinaData);
      doCallAppCallback({ name: AppCallback.DO_TRACK, data: retinaTrackingConfig });
    }
    // fires clever tap  tracking for Apps on Pay Now Button Click
    if (event === TRACKING_EVENTS.PAY_NOW_CLICKED) {
      cleverTapTrackingForApps({
        event: TRACKING_EVENTS.PAYMENT_INITIATED,
        paymentMethod,
        cartInfo,
        isSavedPaymentMethod,
        isWebView: 1,
      });
    }
    // fires  clever tap  tracking for Apps after order create response for all payments(As per IOS)
    if (event === TRACKING_EVENTS.ORDER_CREATED) {
      cleverTapTrackingForApps({
        event: TRACKING_EVENTS.CHECKOUT,
        paymentMethod,
        cartInfo,
        isSavedPaymentMethod,
        isWebView: 1,
      });
    }
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data for web tab actice.
 */
 export const getMixPanelWebInActive = () => ({
      is_web_view: true,
    });

/**
 * @description -- function return mixel panel data for web tab actice.
 */
 export const getMixPanelWebActive = () => ({
      is_web_view: true,
    });

/**
 * @description -- function manipulates data on the event , cartInfo and other parameters
 * @returns -- tracking data for mixpanel
 */
export const getMixPanelTrackingData = ({
  event,
  cartInfo = {},
  paymentInfo = {},
  walletConfig = {},
  paymentMethod = "",
  walletInfo = {},
  offersData = {},
  appliedOfferRuleId,
  addressCount,
  paymentSuccessData = {},
  paymentSuccessItem = {},
  isSavedPaymentMethod,
  upiexpinput_params = "",
  isWebView = true,
  isSimplEligible = false,
  isZestMoneyEligible = false,
  orderId = "",
  paymentAmount,
  interactionLocation,
  isDefaultAddress,
  auto_detect_permission,
  errorMessage,
  credPayData,
  isCredPayInstalled,
  masterPaymentStatus,
  paymentFallbackOptions,
  paymentStatus,
  isExpanded,
  intentApp,
  errorType,
  visibleOffers,
  codCharge,
  paymentGateway,
  nativeOrderConfirmationCallbackData,
  failureFlowEnabled,
  paymentScreen,
  isFirstLandingPageAfterCheckout,
  giftcardAmount,
  paymentMode,
  interaction_location,
  payment_method_shown,
  nykaa_wallet_shown,
  payment_amount,
  payment_method,
  is_logged_in,
  payment_offer_applied,
  savings_amount,
  payable_amount,
  nykaa_wallet_applied,
  nykaa_wallet_balance,
  payment_offer_amount,
  item_count,
  pincode,
  cod_charges_applied,
  cod_charge_amount,
  rewards_amount,
  checkoutExperiments,
}: MixPanelTrackingDataConfig) => {
  try {
    let payment_available_offers = [];
    const expressCheckoutTrackingData = {
      interaction_location,
      payment_method_shown,
      nykaa_wallet_shown,
      payment_amount,
      payment_method,
      is_logged_in,
      payment_offer_applied,
      savings_amount,
      payable_amount,
      nykaa_wallet_applied,
      nykaa_wallet_balance,
      payment_offer_amount,
      item_count,
      pincode,
      cod_charges_applied,
      cod_charge_amount,
      rewards_amount,
    };

    if (Object.keys(offersData) && offersData?.paymentRules) {
      payment_available_offers = getPaymentOffers(offersData?.paymentRules);
    }
    let mixPanelData: any = {};
    switch (event) {
      case TRACKING_EVENTS.SAVED_PAYMENT_LOADS: {
        mixPanelData = getMixpanelPayment1LoadData(
          cartInfo,
          paymentInfo,
          payment_available_offers,
          isWebView,
          visibleOffers,
          failureFlowEnabled,
          isFirstLandingPageAfterCheckout
        );
        return mixPanelData;
      }
      case TRACKING_EVENTS.PAYMENT_PAGE_LOADS: {
        mixPanelData = getMixpanelPayment2LoadData(
          cartInfo,
          walletInfo,
          walletConfig,
          payment_available_offers,
          upiexpinput_params,
          isWebView
        );
        return mixPanelData;
      }
      case TRACKING_EVENTS.CRED_DETAILS: {
        mixPanelData = getMixpanelCredLoadData(
          credPayData,
          isCredPayInstalled,
          isWebView
        );
        return mixPanelData;
      }
      case TRACKING_EVENTS.PAY_NOW_CLICKED: {
        mixPanelData = getMixpanelPayNowClickData(
          cartInfo,
          walletConfig,
          paymentMethod,
          appliedOfferRuleId,
          isSavedPaymentMethod,
          isWebView,
          intentApp,
          codCharge,
          paymentScreen,
          giftcardAmount,
          interactionLocation,
          paymentMode
        );
        return mixPanelData;
      }
      case TRACKING_EVENTS.SAVED_ADDRESS_PAGE_LOAD: {
        mixPanelData = getMixpanelSavedAddressPageData(addressCount, isWebView, isFirstLandingPageAfterCheckout);
        return mixPanelData;
      }
      case TRACKING_EVENTS.ADD_NEW_ADDRESS_PAGE_LOAD: {
        mixPanelData = getMixpanelNewAddressPageData(isWebView, isFirstLandingPageAfterCheckout);
        return mixPanelData;
      }
      case TRACKING_EVENTS.ORDER_PLACED: {
        mixPanelData = getMixPanelPaymentSuccessPageData(paymentSuccessData, isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.ORDER_ITEM_PLACED: {
        mixPanelData = getMixPanelItemOrderPlacedData(paymentSuccessItem, orderId, isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.PAYMENT_METHOD_CLICK: {
        mixPanelData = getMixPanelPaymentModeClickData(
          paymentMethod,
          isWebView,
          isSavedPaymentMethod,
        );
        return mixPanelData;
      }
      case TRACKING_EVENTS.OTHER_PAYMENT_METHOD_CLICK: {
        mixPanelData = getMixPanelOtherPaymentOptionsClickData(isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.PAYMENT_OFFER_WIDGET_CLICK: {
        mixPanelData = getMixPanelPaymentOfferWidgetClickData(payment_available_offers, isWebView, interactionLocation);
        return mixPanelData;
      }
      case TRACKING_EVENTS.PAYMENT_OFFER_CLICKED: {
        mixPanelData = getMixPanelPaymentOfferClickData(isWebView, interactionLocation);
        return mixPanelData;
      }
      case TRACKING_EVENTS.SAVE_CARD_KNOW_MORE: {
        mixPanelData = getMixPanelCardKnowMoreClickData(isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.ORDER_CREATED: {
        mixPanelData = getMixPanelOrderCreatedData(
          cartInfo,
          paymentMethod,
          isSavedPaymentMethod,
          orderId,
          isWebView,
          paymentGateway
        );
        return mixPanelData;
      }
      case TRACKING_EVENTS.PAYMENT_FAILED_EVENT: {
        mixPanelData = getMixPanelPaymentFailedData(
          paymentMethod,
          orderId,
          paymentAmount,
          isWebView,
          paymentStatus
        );
        return mixPanelData;
      }
      case TRACKING_EVENTS.PAYMENT_RESPONSE_STATUS: {
        mixPanelData = getMixPanelPaymentStatusData(
          paymentMethod,
          orderId,
          isWebView,
          paymentStatus
        );
        return mixPanelData;
      }
      case TRACKING_EVENTS.ADDRESS_AUTO_DETECT_CLICK: {
        mixPanelData = getMixPanelAddressAutoDetectClickData(interactionLocation, isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.ADDRESS_AUTO_DETECT_EDIT: {
        mixPanelData = getMixPanelAutoDetectEditData(isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.ADDRESS_AUTO_DEECT_CONFIRM: {
        mixPanelData = getMixPanelAutoDetectConfirmData(isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.EDIT_ADDRESS_LOADS: {
        mixPanelData = getMixPanelEditAddressLoadsData(isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.SHIP_TO_ADDRESS_CLICKS: {
        mixPanelData = getMixPanelShipToAddressClickData(
          isDefaultAddress,
          interactionLocation,
          isWebView
        );
        return mixPanelData;
      }
      case TRACKING_EVENTS.DELIVERY_ESTIMATE_TOOLIP_EXPAND: {
        mixPanelData = getMixPanelExpandDeliveryDateData(interactionLocation, isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.ADDRESS_DETAILS_TOOLTIP_EXPAND: {
        mixPanelData = getMixPanelExpandDeliveryAddressData(interactionLocation, isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.PRICE_DETAILS_TOOPTOP_EXPAND: {
        mixPanelData = getMixPanelExpandPriceDetailsData(interactionLocation, isExpanded, isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.ADDRESS_AUTO_DETECT_INTERACTION: {
        mixPanelData = getMixPanelAddressAutoDetectInteractionData(
          auto_detect_permission,
          isWebView
        );
        return mixPanelData;
      }
      case TRACKING_EVENTS.CARD_SAVED_AS_PER_RBI: {
        mixPanelData = getMixPanelSaveCardClickData(isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.ERROR_PAGE_LOAD: {
        mixPanelData = getMixPanelPageLoadErrorData(interactionLocation, errorMessage, isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.SNPL_ELIGIBILITY_CHECKED: {
        mixPanelData = getMixPanelSNPLEligibilityData(isSimplEligible, isZestMoneyEligible, isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.FAILURE_BOTTOMSHEET_LOAD: {
        mixPanelData = getMixPanelFailureBottomSheetLoadData(masterPaymentStatus, paymentFallbackOptions, isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.FAILURE_BOTTOMSHEET_CROSS_BUTTON_CLICK: {
        mixPanelData = getWebViewObject(isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.FAILURE_BOTTOMSHEET_OTHER_PAYMENT_CLICK: {
        mixPanelData = getWebViewObject(isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.FAILURE_BOTTOMSHEET_RETRY_BUTTON_CLICK: {
        mixPanelData = getWebViewObject(isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.ADD_MONEY_PAYTM: {
        mixPanelData = getMixPanelAddMoneyPaytm(isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.PAYMENT_BACK_FRICTION_LOADS: {
        mixPanelData = getMixPanelBackFrictionData(isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.PAYMENT_BACK_FRICTION_PROCEED: {
        mixPanelData = getMixPanelBackFrictionData(isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.PAYMENT_BACK_FRICTION_CLOSED: {
        mixPanelData = getMixPanelBackFrictionData(isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.PAYMENT_ERROR_POPUP: {
        mixPanelData = getMixPanelErrorPopupOpens(isWebView, errorMessage, errorType);
        return mixPanelData;
      }
      case TRACKING_EVENTS.PAYEMNT_ERROR_POPUP_CLICK: {
        mixPanelData = getMixPanelErrorPopupClick(isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.WEBVIEW_TAB_ACTIVE: {
        mixPanelData = getMixPanelWebActive();
        return mixPanelData;
      }
      case TRACKING_EVENTS.WEBVIEW_TAB_INACTIVE: {
        mixPanelData = getMixPanelWebInActive();
        return mixPanelData;
      }
      case TRACKING_EVENTS.POST_PAYMENT_PAGE_LOADS: {
        mixPanelData = getMixPanelPostPaymentPageLoads(isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.DO_REDIRECT_TO_NATIVE_CONFIRMATION_CALLED: {
        mixPanelData = getMixPanelNativeOrderConfirmationCallbackData(nativeOrderConfirmationCallbackData, isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.HIGH_MEMORY_UTILISATION: {
        mixPanelData = getMixPanelDataForHighMemoryUtilisation(isWebView);
        return mixPanelData;
      }
      case TRACKING_EVENTS.ADDRESS_BACK_BOTTOMSHEET_LOADS: {
        return {};
      }
      case TRACKING_EVENTS.ADDRESS_BACK_BOTTOMSHEET_CLICK: {
        return { interactionLocation };
      }
      case TRACKING_EVENTS.EXPRESS_CHECKOUT_PAGE_LOAD: {
        return expressCheckoutTrackingData;
      }
      case TRACKING_EVENTS.EXPRESS_CHECKOUT_PAY_CLICKED: {
        return expressCheckoutTrackingData;
      }
      case TRACKING_EVENTS.EXPRESS_CHECKOUT_CLOSED: {
        return expressCheckoutTrackingData;
      }
      case TRACKING_EVENTS.EXPRESS_CHECKOUT_ADDRESS_CHANGE: {
        mixPanelData = {
          interaction_location: "expressCheckoutPage",
        };
        return mixPanelData;
      }
      case TRACKING_EVENTS.EXPRESS_CHECKOUT_PAYMENT_MODE_CHANGE: {
        return expressCheckoutTrackingData;
      }
      case TRACKING_EVENTS.EXPRESS_CHECKOUT_ERROR: {
        mixPanelData = getMixpanelExpressCheckoutErrorData(errorType);
        return mixPanelData;
      }
      case TRACKING_EVENTS.EXPRESS_CHECKOUT_PMNA_LOAD: {
        mixPanelData = {
          page_name: "expressCheckoutPage",
        };
        return mixPanelData;
      }
      case TRACKING_EVENTS.CHECKOUT_EXPERIMENTS: {
        mixPanelData = getMixPanelCheckoutExperiments(isWebView, checkoutExperiments);
        return mixPanelData;
      }
      default:
        return {};
    }
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function manipulates data on the event , cartInfo and other parameters
 * @returns -- tracking data for retina
 */
export const getRetinaTrackingData = ({
  event,
  cartInfo = {},
  paymentInfo = {},
  walletConfig = {},
  paymentMethod = "",
  paymentSuccessData = {},
  orderId,
  isWebView,
}: RetinaTrackingDataConfig) => {
  try {
    let retinaData: any = {};
    switch (event) {
      case TRACKING_EVENTS.SAVED_PAYMENT_LOADS: {
        retinaData = getRetinaPayment1LoadData(cartInfo, paymentInfo, isWebView);
        return retinaData;
      }
      case TRACKING_EVENTS.PAYMENT_PAGE_LOADS: {
        retinaData = getRetinaPayment2LoadData(cartInfo, paymentInfo, isWebView);
        return retinaData;
      }
      case TRACKING_EVENTS.PAY_NOW_CLICKED: {
        retinaData = getRetinaPayNowClickData(cartInfo, walletConfig, paymentMethod, isWebView);
        return retinaData;
      }
      case TRACKING_EVENTS.ORDER_CREATED: {
        retinaData = getRetinaOrderCreatedData(cartInfo, walletConfig, paymentMethod, orderId, isWebView);
        return retinaData;
      }
      case TRACKING_EVENTS.ORDER_PLACED: {
        retinaData = getRetinaPaymentSuccessPageData(paymentSuccessData, isWebView);
        return retinaData;
      }
      default:
        return {};
    }
  } catch (e) {
    logger.error(e as Error);
  }
};

const getProductDetailsForTracking = (product: ICartItem, position: number) => {
  try {
    return {
      product_id: product.productId,
      product_mrp: product.cartItemPriceDTO?.mrp,
      product_price: product.cartItemPriceDTO?.price,
      product_dp: product.cartItemPriceDTO?.price, // product discounted price
      product_name: product.name,
      product_sku: product.sku,
      product_quantity: product.quantity,
      product_position: position,
      product_brand: product.brandNames?.[0] || "", // used for retina order created tracking
      product_inventory: product.inventory || "", // used for retina IOS fashion (not getting inventory in refresh call)
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data for payment page 1 load
 */
export const getMixpanelPayment1LoadData = (
  cartInfo: ICartInfo,
  paymentInfo: IPaymentInfo,
  payment_available_offers: string[],
  isWebView: boolean,
  visibleOffers: boolean,
  failureFlowEnabled: boolean,
  isFirstLandingPageAfterCheckout: boolean
) => {
  try {
    const { currencyCode: currency, grandTotal, subTotal, quantity, totalSaved } = cartInfo;
    const cartItemCount = cartInfo?.paymentDetails?.itemCount || 0;
    let {
      savedCardsDisplayed: areSavedPaymentMethodsDisplayed,
      savedMethodsAvailable,
    } = getIsSavedMethodsDisplayed(cartInfo, paymentInfo);
    const savedPaymentMethodsAvailable =
      savedMethodsAvailable?.length > 0 && areSavedPaymentMethodsDisplayed
        ? savedMethodsAvailable
        : NO_SAVED_METHOD;
    const cart_value_bucket = getBucketSize(grandTotal || 0);

    const paymentPage1Data: any = {
      page: PAGE_NAMES.SAVED_PAYMENT_PAGE,
      page_type: PAGE_TYPES.PAYMENT_PAGE,
      cart_product_count: quantity, //total items in cart
      cart_total_qty: cartItemCount, // types of items
      currency,
      cart_total: grandTotal,
      cart_subtotal: subTotal,
      cart_value_bucket,
      cart_discount_applied: totalSaved,
      payment_methods_shown: savedPaymentMethodsAvailable,
      payment_available_offers,
      is_web_view: isWebView,
      is_payment_offer_visible: visibleOffers,
      is_payment_failure_enabled: failureFlowEnabled,
    };
    /**
     * Only pass checkout_success as 1 if it is true otherwise no need to pass
     * https://nykmage.atlassian.net/browse/FC-4310
     */
    if (isFirstLandingPageAfterCheckout) {
      paymentPage1Data["checkout_success"] = 1;
    }
    return paymentPage1Data;
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data for payment page 2 load
 */
export const getMixpanelPayment2LoadData = (
  cartInfo: ICartInfo,
  walletInfo: WalletInfo,
  walletConfig: IWalletConfig,
  payment_available_offers: string[],
  upiexpinput_params: string,
  isWebView: boolean
) => {
  try {
    const {
      currencyCode: currency,
      grandTotal,
      subTotal,
      quantity,
      totalSaved,
      availablePaymentMethods,
    } = cartInfo;
    const cartItemCount = cartInfo?.paymentDetails?.itemCount || 0;
    const cart_value_bucket = getBucketSize(grandTotal || 0);
    const { isVerificationRequired, scWalletEnabled } = walletInfo;
    /**
     * walletBalance -- total amount available in wallet
     */
    const { walletBalance } = walletConfig;

    const wallet_session = isVerificationRequired
      ? SEMI_CLOSED_WALLET_STATES.NOT_VERIFIED
      : SEMI_CLOSED_WALLET_STATES.VERIFIED;
    const wallet_type = scWalletEnabled ? WALLET_STATES.SEMI_CLOSED : WALLET_STATES.CLOSED;
    const otherPaymentMethodsAvailable =
      availablePaymentMethods?.length > 0 ? availablePaymentMethods : NO_OTHER_METHOD;

    return {
      page: PAGE_NAMES.PAYMENT_PAGE,
      page_type: PAGE_TYPES.PAYMENT_PAGE,
      cart_product_count: quantity,
      cart_total_qty: cartItemCount,
      currency,
      cart_total: grandTotal,
      cart_subtotal: subTotal,
      cart_value_bucket,
      cart_discount_applied: totalSaved,
      payment_methods_shown: otherPaymentMethodsAvailable,
      payment_available_offers: payment_available_offers,
      wallet_amount: walletBalance,
      wallet_type,
      wallet_session,
      upiexpinput_params,
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data for pay now click load
 */
export const getMixpanelPayNowClickData = (
  cartInfo: ICartInfo,
  walletConfig: IWalletConfig,
  paymentMethod = "",
  appliedOfferRuleId = 0,
  isSavedPaymentMethod = false,
  isWebView: boolean,
  intentApp = "",
  codCharge = 0,
  paymentScreen = "",
  giftcardAmount = 0,
  currentInteractionLocation = "",
  paymentMode = ""
) => {
  try {
    const { currencyCode: currency, grandTotal } = cartInfo;
    let mode = paymentMode;
    let type = "fresh";
    /**
     * walletAmount- wallet amount used during payment
     */
    const { walletAmount } = walletConfig;
    paymentMethod = isSavedPaymentMethod
      ? `savedDetail:${paymentMethod}`
      : `freshPayment:${paymentMethod}`;
    let interactionLocation = PAGE_NAMES.FRESH_PAYMENT_PAGE;

    /**
     * for saved payment the interaction location is savedPaymentPage
     */
    if (isSavedPaymentMethod || paymentScreen === PAYMENT_SCREENS.SAVED) {
      interactionLocation = PAGE_NAMES.SAVED_PAYMENT_PAGE;
      type = "saved";
    }

    if (currentInteractionLocation) {
      interactionLocation = currentInteractionLocation;
    }

    if (walletAmount && mode !== NEW_PAYMENT_METHODS_DATALAYER.WALLET) {
      mode = NEW_PAYMENT_METHODS_DATALAYER.WALLET + " X " + mode;
    }

    if (giftcardAmount && mode !== NEW_PAYMENT_METHODS_DATALAYER.GIFT_CARD) {
     mode = NEW_PAYMENT_METHODS_DATALAYER.GIFT_CARD + " X " + mode;
    }


    return {
      payment_method: paymentMethod,
      payment_applied_offers: appliedOfferRuleId ? appliedOfferRuleId.toString() : "",
      currency,
      payment_amount: grandTotal,
      is_web_view: isWebView,
      interaction_location: interactionLocation,
      upi_payment_app: intentApp,
      codCharge,
      mode_of_payment: mode,
      type_of_payment: type,
      sub_mode_of_payment: intentApp,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data saved address page load
 */
export const getMixpanelSavedAddressPageData = (addressCount = 0, isWebView: boolean, isFirstLandingPageAfterCheckout: boolean) => {
  try {
    const savedAddressPageData: any = {
      page: PAGE_NAMES.SAVED_ADDRESS,
      page_type: PAGE_TYPES.ADDRESS_PAGE,
      address_view_location: PAGE_NAMES.SAVED_PAYMENT_PAGE,
      interaction_location: PAGE_NAMES.SAVED_PAYMENT_PAGE,
      saved_address_count: addressCount,
      is_web_view: isWebView,
    };

    /**
     * Only pass checkout_success as 1 if it is true otherwise no need to pass
     * https://nykmage.atlassian.net/browse/FC-4310
     */
    if (isFirstLandingPageAfterCheckout) {
      savedAddressPageData["checkout_success"] = 1;
    }
    return savedAddressPageData;
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data add address page load
 */
export const getMixpanelNewAddressPageData = (isWebView: boolean, isFirstLandingPageAfterCheckout: boolean) => {
  try {
    const addAddressPageData: any = {
      page: PAGE_NAMES.ADD_NEW_ADDRESS,
      page_type: PAGE_TYPES.ADDRESS_PAGE,
      add_address_location: PAGE_NAMES.SAVED_ADDRESS,
      interaction_location: PAGE_NAMES.SAVED_ADDRESS,
      is_web_view: isWebView,
    };

    /**
     * Only pass checkout_success as 1 if it is true otherwise no need to pass
     * https://nykmage.atlassian.net/browse/FC-4310
     */
    if (isFirstLandingPageAfterCheckout) {
      addAddressPageData["checkout_success"] = 1;
    }
    return addAddressPageData;
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data for payment success page load
 */
export const getMixPanelPaymentSuccessPageData = (
  paymentSuccessData: IPaymentSuccessData,
  isWebView: boolean
) => {
  try {
    const {
      orderId,
      shippingChargeAmount: cartShipping,
      grandTotalAmount: grandTotal,
      subTotalAmount: subTotal,
      itemsQty,
      itemCount,
      discountAmount,
      paymentMethod,
      shippingAddress,
      items,
    } = paymentSuccessData;
    const cart_value_bucket = getBucketSize(grandTotal || 0);
    let product_with_offer_count = 0;

    try {
      items?.forEach((item: IPaymentSuccessItem) => {
        if (
          item.offerCommunication?.availableOfferIds &&
          item.offerCommunication?.availableOfferIds.length > 0
        ) {
          product_with_offer_count++;
        }
      });
    } catch (error) {
      logger.error(error as Error, "Error in getting the cart items with offer count");
    }

    return {
      order_id: orderId,
      cart_product_count: itemsQty,
      product_id_list: items?.map(x => x.parentId || NOT_AVAILABLE),
      variant_product_id_list: items?.map(x => x.productId || NOT_AVAILABLE),
      product_type_list: items?.map(x => x.productType || NOT_AVAILABLE),
      product_name_list: items?.map(x => x.name || NOT_AVAILABLE),
      brand_name_list: items?.map(x =>
        Array.isArray(x.brandNames) && x.brandNames.length > 0 ? x.brandNames[0] : NOT_AVAILABLE
      ),
      category_l1_name_list: items?.map(x => x.l1CategoryName || NOT_AVAILABLE),
      category_l2_name_list: items?.map(x => x.l2CategoryName || NOT_AVAILABLE),
      category_l3_name_list: items?.map(x => x.l3CategoryName || NOT_AVAILABLE),
      cart_total_qty: itemCount, //item-types
      currency: "INR",
      cart_total: grandTotal,
      cart_subtotal: subTotal,
      cart_value_bucket,
      shipping_charges: cartShipping,
      product_with_offer_count, // TO DO -- not getting key
      cart_discount_applied: discountAmount,
      payment_method: paymentMethod,
      pincode_value: shippingAddress?.pincode || "NA",
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data for each product in order placed
 */
export const getMixPanelItemOrderPlacedData = (
  paymentSuccessItem: IPaymentSuccessItem,
  orderId = "",
  isWebView: boolean
) => {
  try {
    const {
      productId,
      quantity,
      actualPrice,
      totalPrice,
      productType,
      name,
      brandNames,
      l1CategoryName,
      l2CategoryName,
      l3CategoryName,
      packSize,
      parentId,
    } = paymentSuccessItem;
    return {
      order_id: orderId,
      product_id: parentId,
      variant_type: packSize || "",
      variant_product_id: productId,
      product_type: productType,
      product_name: name,
      product_store: "", //TO DO -- Not getting key
      brand_name: brandNames?.[0],
      category_l1_name: l1CategoryName,
      category_l2_name: l2CategoryName,
      category_l3_name: l3CategoryName,
      quantity,
      currency: "INR",
      mrp_price: actualPrice,
      discounted_price: totalPrice,
      applied_offer_id: "", // TO DO - (Not getting Key)
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data on expanding payment mode click
 */
export const getMixPanelPaymentModeClickData = (
  paymentMethod: string,
  isWebView: boolean,
  isSavedPaymentMethod = false,
) => {
  const interactionLocation = isSavedPaymentMethod
    ? PAGE_NAMES.SAVED_PAYMENT_PAGE
    : PAGE_NAMES.FRESH_PAYMENT_PAGE;
  try {
    return {
      payment_mode: isSavedPaymentMethod
        ? `savedDetail:${paymentMethod}`
        : `freshPayment:${paymentMethod}`,
      payment_method: paymentMethod,
      interaction_location: interactionLocation,
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data on other payment options click
 */
export const getMixPanelOtherPaymentOptionsClickData = (isWebView: boolean) => {
  try {
    return {
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data for CredPay
 */
export const getMixpanelCredLoadData = ( credPayData: {
  credFlow: string,
  credOffer: string,
  eligible: boolean
}, isCredPayInstalled: boolean,
  isWebView: boolean) => {
    let isCredEligible = false;
    if (Object.keys(credPayData)?.length) {
      if (credPayData?.eligible) {
        isCredEligible = true;
      }
    }
  try {
    return {
      isCredPresent: isCredPayInstalled,
      isCredEligible: isCredEligible,
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data on payment offers widget click
 */
export const getMixPanelPaymentOfferWidgetClickData = (
  payment_available_offers: string[],
  isWebView: boolean,
  interactionLocation?: string
) => {
  try {
    return {
      payment_available_offers,
      interaction_location: interactionLocation,
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data on payment offers click
 */
 export const getMixPanelPaymentOfferClickData = (
  isWebView: boolean,
  interactionLocation?: string
) => {
  try {
    return {
      interaction_location: interactionLocation,
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data on save card checkbox click
 */
export const getMixPanelCardKnowMoreClickData = (isWebView: boolean) => {
  try {
    return {
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel order created data
 */
export const getMixPanelOrderCreatedData = (
  cartInfo: ICartInfo,
  paymentMethod = "",
  isSavedPaymentMethod: boolean,
  orderId = "",
  isWebView: boolean,
  paymentGateway: string,
) => {
  try {
    const {
      currencyCode: currency,
      grandTotal,
      subTotal,
      quantity,
      totalSaved,
      shippingCharge,
      items,
      bagDiscount,
      couponDiscount,
      shippingAddress: { postcode },
    } = cartInfo;
    const cartItemCount = cartInfo?.paymentDetails?.itemCount || 0;
    const cart_value_bucket = getBucketSize(grandTotal || 0);
    let product_with_offer_count = 0;
    items?.forEach((item: ICartItem) => {
      if (item.offerCommunication?.availableOfferIds?.length > 0) {
        product_with_offer_count++;
      }
    });
    // check categories later
    return {
      order_id: orderId,
      cart_product_count: quantity,
      product_id_list: items?.map(x => x.parentId || NOT_AVAILABLE),
      variant_product_id_list: items?.map(x => x.productId),
      product_type_list: items?.map(x => x.productType || NOT_AVAILABLE),
      product_name_list: items?.map(x => x.name || NOT_AVAILABLE),
      brand_name_list: items?.map(x =>
        Array.isArray(x.brandNames) && x.brandNames.length > 0 ? x.brandNames[0] : NOT_AVAILABLE
      ),
      category_l1_name_list: items?.map(x => x.primaryCategories?.l1?.name || NOT_AVAILABLE),
      category_l2_name_list: items?.map(x => x.primaryCategories?.l2?.name || NOT_AVAILABLE),
      category_l3_name_list: items?.map(x => x.primaryCategories?.l3?.name || NOT_AVAILABLE),
      cart_total_qty: cartItemCount,
      currency,
      cart_total: grandTotal,
      cart_subtotal: subTotal,
      cart_value_bucket,
      shipping_charges: shippingCharge,
      product_with_offer_count,
      cart_discount_applied: totalSaved,
      is_web_view: isWebView,
      payment_method: isSavedPaymentMethod
        ? `savedDetail:${paymentMethod}`
        : `freshPayment:${paymentMethod}`,
      pincode_value: postcode || "NA",
      cart_bag_discount_applied: bagDiscount,
      cart_offer_discount_applied: couponDiscount,
      paymentGateway,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data  on payment failure
 */
export const getMixPanelPaymentFailedData = (
  paymentMethod: string,
  orderId = "",
  paymentAmount = 0,
  isWebView: boolean,
  paymentStatus = ""
) => {
  try {
    return {
      order_id: orderId,
      error_message: "",
      payment_method: paymentMethod,
      payment_amount: paymentAmount,
      is_web_view: isWebView,
      payment_status: paymentStatus,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data  after payment response api call
 */
 export const getMixPanelPaymentStatusData = (
  paymentMethod: string,
  orderId = "",
  isWebView: boolean,
  paymentStatus = ""
) => {
  try {
    return {
      order_id: orderId,
      payment_method: paymentMethod,
      is_web_view: isWebView,
      payment_status: paymentStatus,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data  on address auto detect click
 */
export const getMixPanelAddressAutoDetectClickData = (
  interactionLocation = "",
  isWebView: boolean
) => {
  try {
    return {
      interaction_location: interactionLocation,
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data  on edit button click on address auto detected bottomsheet
 */
export const getMixPanelAutoDetectEditData = (isWebView: boolean) => {
  try {
    return {
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data  on confirm button click on address auto detected bottomsheet
 */
export const getMixPanelAutoDetectConfirmData = (isWebView: boolean) => {
  try {
    return {
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data  on back friction bottom sheet loads, closed and proceed
 */
 export const getMixPanelBackFrictionData = (isWebView: boolean) => {
  try {
    return {
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data  on edit address button click
 */
export const getMixPanelEditAddressLoadsData = (isWebView: boolean) => {
  try {
    return {
      page: PAGE_NAMES.EDIT_ADDRESS_PAGE,
      page_type: PAGE_TYPES.ADDRESS_PAGE,
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data for error modal with message and type.
 */
 export const getMixPanelErrorPopupOpens = (isWebView: boolean, errorMessage = "", errorType = "") => {
  try {
    return {
      is_web_view: isWebView,
      errorMessage,
      errorType,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data for error modal close click.
 */
 export const getMixPanelErrorPopupClick = (isWebView: boolean) => {
  try {
    return {
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data for post payment page loads.
 */
 export const getMixPanelPostPaymentPageLoads = (isWebView: boolean) => {
  try {
    return {
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data  on "ship to this Address button click"
 */
export const getMixPanelShipToAddressClickData = (
  isDefaultAddress = false,
  interactionLocation = "",
  isWebView: boolean
) => {
  try {
    return {
      is_default_address: isDefaultAddress,
      interaction_location: interactionLocation,
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- this function returns mixel panel data when doOpenNativeConfirmation is called
 */
export const getMixPanelNativeOrderConfirmationCallbackData = (
  nativeOrderConfirmationCallbackData = {},
  isWebView: boolean
) => {
  try {
    return {
      ...nativeOrderConfirmationCallbackData,
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data  on expanding delivery section
 */
export const getMixPanelDataForHighMemoryUtilisation = (isWebView: boolean) => {
  try {
    return {
      url: window.location.href,
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};


/**
 * @description -- function return mixel panel data  on expanding delivery section
 */
export const getMixPanelExpandDeliveryDateData = (interactionLocation = "", isWebView: boolean) => {
  try {
    return {
      interaction_location: interactionLocation,
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};
/**
 * @description -- function return mixel panel data  on expanding delivery section
 */
export const getMixPanelExpandDeliveryAddressData = (
  interactionLocation = "",
  isWebView: boolean
) => {
  try {
    return {
      interaction_location: interactionLocation,
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data  on expanding delivery section
 */
export const getMixPanelExpandPriceDetailsData = (interactionLocation = "", isExpanded = true, isWebView: boolean) => {
  try {
    return {
      interaction_location: interactionLocation,
      is_expanded: isExpanded,
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data whether location permission is allowed by user or not
 */
export const getMixPanelAddressAutoDetectInteractionData = (
  auto_detect_permission = "",
  isWebView: boolean
) => {
  try {
    return {
      auto_detect_permission,
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data on save card checkbox click
 */
export const getMixPanelSaveCardClickData = (isWebView: boolean) => {
  try {
    return {
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data for add money paytm.
 */
 export const getMixPanelAddMoneyPaytm = (isWebView: boolean) => {
  try {
    return {
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data on page load error
 */
export const getMixPanelPageLoadErrorData = (
  interactionLocation = "",
  errorMessage = "",
  isWebView: boolean
) => {
  try {
    return {
      interaction_location: interactionLocation,
      error_reason: errorMessage,
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};
/**
 * @description -- function return mixel panel data on expanding snpl payment method
 */
 export const getMixPanelSNPLEligibilityData = (
  isSimplEligible = false,
  isZestMoneyEligible = false,
  isWebView: boolean
) => {
  try {
    return {
      is_zest_eligible: isZestMoneyEligible,
      is_simpl_eligible: isSimplEligible,
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data on payment failure bottomsheet load
 * @param masterPaymentStatus -- return the status of the payment
 * @param paymentFallbackOptions -- boolean value for fallbackPaymentOptions exists on bottomsheet or not
 * @param isWebView -- key to confirm event is firing from webview
 */
 export const getMixPanelFailureBottomSheetLoadData = (
  masterPaymentStatus: string,
  paymentFallbackOptions: boolean,
  isWebView: boolean
) => {
  try {
    return {
      payment_failure_status: masterPaymentStatus,
      payment_fallback_option_shown: paymentFallbackOptions,
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function to get webview object(i.e is_web_view)
 * @param isWebView -- boolean key
 */
 export const getWebViewObject = (
  isWebView: boolean
) => {
  try {
    return {
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};
/**
 * @description -- function return retina data for payment page 1 load
 */
export const getRetinaPayment1LoadData = (cartInfo: ICartInfo, paymentInfo: IPaymentInfo, isWebView = false) => {
  try {
    const {
      shippingCharge,
      currencyCode: currency,
      grandTotal,
      subTotal,
      couponDiscount,
      quantity,
      items,
      bagDiscount,
      bagTotal,
    } = cartInfo;
    const cartItemCount = cartInfo?.paymentDetails?.itemCount || 0;
    let {
      savedCardsDisplayed: areSavedPaymentMethodsDisplayed,
      savedMethodsAvailable,
    } = getIsSavedMethodsDisplayed(cartInfo, paymentInfo);
    const products =
      Array.isArray(items) &&
      items?.map((item: ICartItem, index) => getProductDetailsForTracking(item, index + 1));

    const savedPaymentMethodsAvailable = areSavedPaymentMethodsDisplayed
      ? savedMethodsAvailable
      : NO_SAVED_METHOD;

    return {
      page_type: "cart",
      cart_value: bagTotal,
      cart_currency: currency,
      cart_discount: bagDiscount,
      products,
      saved_payment_methods: savedPaymentMethodsAvailable,
      page_name: "payment_page1",
      cart_total: grandTotal,
      cart_item_count: cartItemCount,
      cart_coupon_discount: couponDiscount,
      cart_product_count: quantity,
      event_type: "load",
      event_name: "page_load",
      cart_shipping: shippingCharge,
      cart_subtotal: subTotal,
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return retina data for payment page 2 load
 */
export const getRetinaPayment2LoadData = (cartInfo: ICartInfo, paymentInfo: IPaymentInfo, isWebView = false) => {
  try {
    const {
      shippingCharge,
      currencyCode: currency,
      grandTotal,
      subTotal,
      couponDiscount,
      quantity,
      items,
      bagDiscount,
      availablePaymentMethods,
      bagTotal,
    } = cartInfo;
    const cartItemCount = cartInfo?.paymentDetails?.itemCount || 0;
    let {
      savedCardsDisplayed: areSavedPaymentMethodsDisplayed,
      savedMethodsAvailable,
    } = getIsSavedMethodsDisplayed(cartInfo, paymentInfo);
    const products =
      Array.isArray(items) &&
      items?.map((item: ICartItem, index) => getProductDetailsForTracking(item, index + 1));

    const savedPaymentMethodsAvailable = areSavedPaymentMethodsDisplayed
      ? savedMethodsAvailable
      : NO_SAVED_METHOD;
    const otherPaymentMethodsAvailable = availablePaymentMethods
      ? availablePaymentMethods
      : NO_OTHER_METHOD;

    return {
      available_payment_methods: otherPaymentMethodsAvailable, // check whether this is array or not
      saved_payment_methods: savedPaymentMethodsAvailable,
      cart_coupon_discount: couponDiscount,
      cart_currency: currency,
      cart_discount: bagDiscount,
      cart_item_count: cartItemCount,
      cart_product_count: quantity,
      cart_shipping: shippingCharge,
      cart_subtotal: subTotal,
      cart_total: grandTotal,
      cart_value: bagTotal,
      event_name: "page_load",
      event_type: "load",
      page_name: "payment_page2",
      page_type: "cart",
      products,
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return retina data for pay now botton clicked
 */

export const getRetinaPayNowClickData = (
  cartInfo: ICartInfo,
  walletConfig: IWalletConfig,
  paymentMethod = "",
  isWebView = false
) => {
  try {
    const {
      shippingCharge,
      currencyCode: currency,
      grandTotal,
      subTotal,
      couponDiscount,
      quantity,
      items,
      bagDiscount,
      bagTotal,
    } = cartInfo;
    const cartItemCount = cartInfo?.paymentDetails?.itemCount || 0;
    const products =
      Array.isArray(items) &&
      items?.map((item: ICartItem, index) => getProductDetailsForTracking(item, index + 1));
    /**
     * walletBalance -- total amount available in wallet
     * walletAmount- wallet amount used during payment
     */
    const { walletAmount } = walletConfig;
    const selected_payment_modes = [];
    if (paymentMethod) {
      selected_payment_modes.push(paymentMethod);
      if (walletAmount > 0) {
        selected_payment_modes.push("wallet");
      }
    }
    return {
      cart_value: bagTotal,
      cart_shipping: shippingCharge,
      selected_payment_modes,
      cart_item_count: cartItemCount,
      cart_currency: currency,
      cart_total: grandTotal,
      cart_discount: bagDiscount,
      page_type: "cart",
      event_type: "click",
      cart_coupon_discount: couponDiscount,
      page_name: "payment_page2",
      cart_product_count: quantity,
      products,
      cart_subtotal: subTotal,
      event_name: "payment_confirmation",
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return retina data for pay now botton clicked
 */

export const getRetinaOrderCreatedData = (
  cartInfo: ICartInfo,
  walletConfig: IWalletConfig,
  paymentMethod = "",
  orderId = "",
  isWebView = false,
) => {
  try {
    const { items, currencyCode: currency } = cartInfo;
    const products =
      Array.isArray(items) &&
      items?.map((item: ICartItem, index) => getProductDetailsForTracking(item, index + 1));
    /**
     * walletBalance -- total amount available in wallet
     * walletAmount- wallet amount used during payment
     */
    const { walletAmount } = walletConfig;
    const selected_payment_modes = [];
    if (paymentMethod) {
      selected_payment_modes.push(paymentMethod);
      if (walletAmount > 0) {
        selected_payment_modes.push("wallet");
      }
    }
    return {
      payment_modes: selected_payment_modes,
      cart_currency: currency || "INR",
      event_type: "system",
      products,
      event_name: "order_created",
      order_id: orderId,
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return retina data for pay now botton clicked
 */
export const getRetinaPaymentSuccessPageData = (paymentSuccessData: IPaymentSuccessData, isWebView = false) => {
  try {
    const {
      firstPurchase,
      itemsQty,
      shippingAddress,
      discountAmount,
      orderId,
      shippingChargeAmount,
      subTotalAmount,
      grandTotalAmount,
      paymentMethod,
      items,
    } = paymentSuccessData;
    const order_date = new Date() / 1000;
    let payment_modes = [];
    if (paymentMethod) {
      payment_modes.push(paymentMethod);
    }
    return {
      event_name: "page_load",
      event_type: "load",
      is_first_purchase: firstPurchase,
      order_bucket_size: itemsQty,
      order_city: shippingAddress?.city,
      order_coupon_discount: 0, // Not getting any key for coupon
      order_currency: "INR",
      order_date,
      order_discount: discountAmount,
      order_id: orderId,
      order_shipping: shippingChargeAmount,
      order_state: shippingAddress?.state,
      order_subtotal: subTotalAmount,
      order_total: grandTotalAmount,
      page_name: "order_confirmation",
      page_type: "cart",
      payment_modes,
      products:
        items?.length > 0 &&
        items?.map((product: IPaymentSuccessItem, index: number) => getPurchasedProductDetailsForTracking(product, index + 1)),
      is_web_view: isWebView,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function returns the retina tracking product details on payment success page
 */
const getPurchasedProductDetailsForTracking = (product: IPaymentSuccessItem, position: number) => {
  try {
    return {
      product_brand: product.brandNames?.[0] || "",
      product_id: product.productId,
      product_mrp: product.actualPrice,
      product_dp: product.totalPrice,
      product_name: product.name,
      product_sku: product.itemId,
      product_quantity: product.quantity,
      product_position: position,
      product_price: product.actualPrice,
      product_inventory: product.inventory || "", // used for retina IOS fashion
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * function to get the clevertap tracking data for apps
 */
export const cleverTapTrackingForApps = ({
  event,
  paymentMethod = "",
  cartInfo = {},
  amount,
  isSavedPaymentMethod,
  orderId = "",
  isWebView = 1,
}: ICleverTapTrackingConfig) => {
  try {
    let clevertapData: any = {};
    switch (event) {
      case TRACKING_EVENTS.PAYMENT_INITIATED:
        {
          clevertapData = getClevertapDataForPaymentInitiated(
            paymentMethod,
            cartInfo,
            isWebView,
          );
        }
        break;
      case TRACKING_EVENTS.PAYMENT_FAILED:
        {
          clevertapData = getClevertapDataForPaymentFailed(paymentMethod, amount, orderId, isSavedPaymentMethod, isWebView);
        }
        break;
      case TRACKING_EVENTS.PAYMENT_SUCCESSFUL:
        {
          clevertapData = getClevertapDataForPaymentSuccess(paymentMethod, amount, isSavedPaymentMethod, isWebView);
        }
        break;
      case TRACKING_EVENTS.CHECKOUT:
        {
          clevertapData = getClevertapDataForOrderCreatedonFreshPayment(paymentMethod, cartInfo, isSavedPaymentMethod, isWebView);
        }
        break;
      default:
        clevertapData = {};
        break;
    }
    const clevertapTrackingConfig = {
      tracker: "clevertap",
      type: "state",
      name: event, // name of event/action
      data: JSON.stringify(clevertapData),
    };
    // firing clevertap tracking for apps
    if (clevertapData && Object.keys(clevertapData)?.length > 0) {
      console.log(event, "clevertapData inside cleverTapTrackingForApps", clevertapData);
      doCallAppCallback({ name: AppCallback.DO_TRACK, data: clevertapTrackingConfig });
    }
  } catch (e) {
    logger.error(e as Error);
  }
};
/**
 * @description -- function returns clevertap data on pay now click
 */
export const getClevertapDataForPaymentInitiated = (
  paymentMethod: string,
  cartInfo: ICartInfo,
  isSavedPaymentMethod = false,
  isWebView = 1
) => {
  try {
    const { grandTotal, subTotal, totalSaved, shippingCharge } = cartInfo;
    return {
      payment_method: trackingPaymentMethodMapper(paymentMethod, isSavedPaymentMethod),
      cart_subtotal: subTotal ? subTotal.toFixed(2) : "",
      cart_grandtotal: grandTotal ? grandTotal?.toFixed(2) : "",
      net_savings: totalSaved ? totalSaved?.toFixed(2) : "",
      ship_charge: shippingCharge ? shippingCharge.toFixed(2) : "",
      web_view: isWebView?.toString(),
  };} catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function returns clevertap data on payment failed
 */
export const getClevertapDataForPaymentFailed = (
  paymentMethod: string,
  amount = 0,
  orderId: string,
  isSavedPaymentMethod = false,
  isWebView = 1
) => {
  try {
    return {
      payment_method: trackingPaymentMethodMapper(paymentMethod, isSavedPaymentMethod),
      amount: amount ? amount?.toFixed(2) : "",
      order_id: orderId,
      web_view: isWebView?.toString(),
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function returns clevertap data on payment success
 */
export const getClevertapDataForPaymentSuccess = (paymentMethod: string, amount = 0, isSavedPaymentMethod = false, isWebView = 1) => {
  try {
    return {
      payment_method: trackingPaymentMethodMapper(paymentMethod, isSavedPaymentMethod),
      amount: amount ? amount?.toFixed(2) : "",
      web_view: isWebView?.toString(),
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function returns clevertap data on order creation for fresh payment page
 */
export const getClevertapDataForOrderCreatedonFreshPayment = (paymentMethod: string, cartInfo: ICartInfo, isSavedPaymentMethod = false, isWebView = 1) => {
  try {
    const {
      subTotal,
      grandTotal,
      totalSaved,
      shippingCharge,
      shippingAddress: { city, state, postcode },
    } = cartInfo;
    return {
      payment_method: trackingPaymentMethodMapper(paymentMethod, isSavedPaymentMethod),
      cart_subtotal: subTotal ? subTotal?.toFixed(2) : "",
      cart_grandtotal: grandTotal ? grandTotal?.toFixed(2) : "",
      net_savings: totalSaved ? totalSaved?.toFixed(2) : "",
      ship_charge: shippingCharge ? shippingCharge?.toFixed(2) : "",
      shipping_city: city,
      shipping_pincode: postcode,
      shipping_state: state,
      web_view: isWebView?.toString(),
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function to trigger retina events for web
 */
export const triggerRetinaEventForWeb = (isApp: boolean, data: any) => {
  try {
    if (!isApp && checkIsRetinaEventEnabledByCode() && data && Object.keys(data)) {
      window?.na?.sendEvent(data.event_name, data);
    }
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * trackingPaymentMethodMapper -- returns payment method name
 */

 export const trackingPaymentMethodMapper = (
   paymentMethod: string,
   isSavedPaymentMethod: boolean
 ) => {
   if (isSavedPaymentMethod && paymentMethod == PAYMENT_METHODS_DATALAYER.SIMPL) {
      return PAYMENT_METHODS_DATALAYER.SAVED_SIMPL;
   } else {
     switch (paymentMethod) {
       case PAYMENT_METHODS_DATALAYER.UPI:
         return "UPI";
       case PAYMENT_METHODS_DATALAYER.GOOGLE_PAY:
         return "Google Pay";
       case PAYMENT_METHODS_DATALAYER.COD:
         return "cod";
       case PAYMENT_METHODS_DATALAYER.PAYTM:
         return "Paytm";
       case PAYMENT_METHODS_DATALAYER.GC:
         return "gift";
       case PAYMENT_METHODS_DATALAYER.EMI:
         return "emi";
       case PAYMENT_METHODS_DATALAYER.ZEST:
         return "zest_money";
       case PAYMENT_METHODS_DATALAYER.SIMPL:
         return "simpl";
       default:
         return paymentMethod;
     }
   }
 };

 /**
 * @description -- function return mixel panel data checkout experiments
 */
 export const getMixPanelCheckoutExperiments = (isWebView: boolean, checkoutExperiments: any) => {
  try {
    return {
      is_web_view: isWebView,
      checkoutExperiments: checkoutExperiments,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

 /**
 * @description -- function return mixel panel data of express checkout page load
 */
export const getMixpanelExpressCheckoutPageLoadData = (
  isAddressServicable: boolean,
  isWalletShown: boolean,
  isWalletVerified: boolean,
  paymentMethod: string,
) => {
  try {
    return {
      is_address_servicable: isAddressServicable,
      is_wallet_shown: isWalletShown,
      is_wallet_verified: isWalletVerified,
      payment_method: paymentMethod,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data of express checkout pay button clicked
 */
export const getMixpanelExpressCheckoutPayClickedData = (
  redirectingUserToPaymentPage: boolean,
  paymentAmount: number,
  isLoggedIn: boolean,
  currency: string,
  paymentMethod?: string,
) => {
  try {
    return {
      redirecting_user_to_payment_page: redirectingUserToPaymentPage,
      payment_amount: paymentAmount,
      is_logged_in: isLoggedIn,
      currency: currency,
      payment_method: paymentMethod || NOT_AVAILABLE,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data of express checkout page load
 */
export const getMixpanelExpressCheckoutClosedData = (
  interactionLocation?: string,
) => {
  try {
    return {
      interaction_location: interactionLocation,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};

/**
 * @description -- function return mixel panel data of express error
 */
export const getMixpanelExpressCheckoutErrorData = (
  errorType?: string,
) => {
  try {
    return {
      error_type: errorType,
    };
  } catch (e) {
    logger.error(e as Error);
  }
};
